import React, { useState } from "react";
import { createPortal } from "react-dom";

const SIZE = 300;

// Wraps its children in a div; hovering anywhere on it floats a larger copy of
// `src` beside the cursor. Portaled to <body> so dropdown menus and table rows
// with overflow can't clip it.
const ImageZoom = ({ src, children, ...rest }) => {
  const [pos, setPos] = useState(null);

  return (
    <div
      {...rest}
      onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })}
      onMouseLeave={() => setPos(null)}
    >
      {children}
      {pos &&
        src &&
        createPortal(
          <img
            src={src}
            alt=""
            style={{
              position: "fixed",
              left: Math.min(pos.x + 20, window.innerWidth - SIZE - 8),
              top: Math.max(8, Math.min(pos.y - SIZE / 2, window.innerHeight - SIZE - 8)),
              width: SIZE,
              height: SIZE,
              objectFit: "contain",
              background: "#fff",
              border: "1px solid #ccc",
              borderRadius: 8,
              boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
              pointerEvents: "none",
              zIndex: 2000,
            }}
          />,
          document.body
        )}
    </div>
  );
};

export default ImageZoom;
